enum CollectDataField {
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn'
}
export default CollectDataField
